import { render, staticRenderFns } from "./refuseModal.vue?vue&type=template&id=38ef5dcc&scoped=true&"
import script from "./refuseModal.vue?vue&type=script&lang=js&"
export * from "./refuseModal.vue?vue&type=script&lang=js&"
import style0 from "./refuseModal.vue?vue&type=style&index=0&id=38ef5dcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef5dcc",
  null
  
)

export default component.exports